import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  // SideBarCard,
  SideBarCardData
} from '../StyledComponents/StyledSideBar';
import {
  Title,
  // AuthorAndTime,
  ListElement,
  StyledLine,
  StyledLineInside,
  CardHolder,
  FlexContainer,
  Image
  // Rating
} from '../StyledComponents';
import { rootConfig } from '../../../config/config';

const List_XS_Image = props => {
  // console.log(' props: ', props);
  const { title, listItems } = props;
  let cardItems = listItems.map(listItem => (
    <FlexContainer
      key={listItem.id}
      onClick={() => navigate(listItem.postSlug)}
      className="mv2 pointer"
    >
      <div className="ImageDiv relative">
        <Image
          width="76px"
          height="50px"
          src={
            listItem.featuredImage
              ? `${rootConfig.imagesRoot}/${listItem.featuredImage.file}`
              : null
          }
          alt={listItem.postSlug}
        />
      </div>
      <SideBarCardData>
        <Title
          fontFamily="Nunito"
          fontSize="0.875rem"
          fontWeight="bold"
          lineheight="1.57"
          padding="0 0 0 14px"
        >
          {listItem.postTitle}
        </Title>
      </SideBarCardData>
    </FlexContainer>
  ));

  const navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    props.history.push(`/${postSlug}`);
  };

  return (
    <div className={props.className}>
      <ListElement className="w-100" padding="14px">
        <Title fontFamily="Montserrat" fontSize="1.5rem" fontWeight="bold">
          {title}
        </Title>
        <StyledLine>
          <StyledLineInside />
        </StyledLine>
        <CardHolder> {cardItems} </CardHolder>
      </ListElement>
    </div>
  );
};

export default withRouter(List_XS_Image);
